import { defineStore } from 'pinia';

import {
  RESET_ARTICLE_EDITOR,
  IMPORT_ARTICLE_TO_EDITOR,
  ADD_MULTI_ROW_VALUE,
  UPDATE_MULTI_ROW_VALUE,
  REMOVE_MULTI_ROW_VALUE,
  REMOVE_VALUE_FROM_ARRAY,
} from '@/store/mutation-types';
import { merge } from 'lodash';
import { WorkflowStatus } from '@/workflow-status';

export const useMarinLitEditorStore = defineStore('marinLitEditor', {

  // STATE
  state: () => ({
    article: {
      articleId: '',
      authors: [{ firstName: '', lastName: '' }],
      categories: [],
      doi: '',
      firstPage: '',
      issueNumber: '',
      journalTitle: '',
      journalVolume: '',
      lastPage: '',
      note: '',
      relatedArticles: [],
      status: WorkflowStatus.DRAFT,
      substances: [],
      subsYear: '',
      taxonomies: [],
      title: '',
      trivialNames: [],
    },
  }),

  // ACTIONS
  actions: {
    [RESET_ARTICLE_EDITOR]() {
      this.article = {
        articleId: '',
        authors: [{ firstName: '', lastName: '' }],
        categories: [],
        doi: '',
        firstPage: '',
        issueNumber: '',
        journalTitle: '',
        journalVolume: '',
        lastPage: '',
        note: '',
        relatedArticles: [],
        status: WorkflowStatus.DRAFT,
        substances: [],
        subsYear: '',
        taxonomies: [],
        title: '',
        trivialNames: [],
      };
    },
    [IMPORT_ARTICLE_TO_EDITOR](payload) {
      merge(this.article, payload.article);
    },
    [ADD_MULTI_ROW_VALUE](payload) {
      this.article[payload.key].push(payload.value);
    },
    [UPDATE_MULTI_ROW_VALUE](payload) {
      this.article[payload.key].splice(payload.index, 1, payload.value);
    },
    [REMOVE_MULTI_ROW_VALUE](payload) {
      this.article[payload.key].splice(payload.index, 1);
    },
    [REMOVE_VALUE_FROM_ARRAY](payload) {
      const index = this.article[payload.key].indexOf(payload.value);
      if (index !== -1) {
        this.article[payload.key].splice(index, 1);
      }
    },
    updateField({ path, value }) {
      const segments = path.split('.');
      let target = this;
      for (let i = 0; i < segments.length - 1; i++) {
        if (!(segments[i] in target)) {
          target[segments[i]] = {}; // create intermediate object if it does not exist
        }
        target = target[segments[i]];
      }
      target[segments[segments.length - 1]] = value;
    },

    resetArticleEditorAction() {
      this[RESET_ARTICLE_EDITOR]();
    },

    importArticleToEditorAction(article) {
      this[RESET_ARTICLE_EDITOR]();
      this[IMPORT_ARTICLE_TO_EDITOR]({ article });
    },

    addAuthorRowAction() {
      this[ADD_MULTI_ROW_VALUE]({
        key: 'authors',
        value: { firstName: '', lastName: '' }
      });
    },

    addTaxonomyRowAction(value) {
      this[ADD_MULTI_ROW_VALUE]({
        key: 'taxonomies',
        value
      });
    },

    addMultiRowValueAction({ key, value }) {
      this[ADD_MULTI_ROW_VALUE]({
        key,
        value
      });
    },

    updateMultiRowValueAction({ key, index, value }) {
      this[UPDATE_MULTI_ROW_VALUE]({
        key,
        index,
        value
      });
    },

    deleteMultiRowValueAction({ key, index }) {
      this[REMOVE_MULTI_ROW_VALUE]({
        key,
        index
      });
    },

    removeValueFromArrayAction({ key, value }) {
      this[REMOVE_VALUE_FROM_ARRAY]({
        key,
        value
      });
    },
  },

});
